import { Controller } from 'stimulus'

export default class extends Controller {

  choose(event) {
    this.element.querySelectorAll('[data-panel]').forEach(panel => {
      const shown = panel.getAttribute('data-panel') === event.target.value
      panel.classList.toggle('d-none', !shown)
      panel.querySelector('select').disabled = !shown
    })
  }
}
